export default __webpack_public_path__ + "static/media/260.eedd89bf.jpg";